// 与 software_info 表字段长度保持一致
export const SERVER_IP_MAX_LENGTH = 512;
export const ICP_NUMBER_MAX_LENGTH = 255;

// 通用正则规则
export const REG_TYPES = {
  mobile: {
    len: 11,
    pattern: /^1[3|4|5|6|7|8|9][0-9]{9}$/,
    message: '请输入正确手机号'
  },
  number: {
    pattern: /^[0-9]*$/,
    message: '请输入数字'
  },
  limits: {
    pattern: /^.{2,30}$/,
    message: '请输入2-30个字'
  },
  limit20: {
    pattern: /^.{1,20}$/,
    message: '请输入1-20个字'
  },
  limit100: {
    pattern: /^.{1,100}$/,
    message: '请输入1-100个字'
  },
  limit255: {
    pattern: /^.{0,255}$/,
    message: '最多输入255个字符'
  },
  limit512: {
    pattern: /^.{1,512}$/,
    message: '最多输入512个字符'
  },
  // 包含标点符号、空格换行
  limit300: {
    pattern: /^[^\\]{0,300}$/,
    message: '请输入1-300个字'
  },
  chinese: {
    pattern: /^[\u4e00-\u9fa5]+$/,
    message: '请输入中文'
  },
  cEnglish: {
    pattern: /^[\u4e00-\u9fa5a-zA-Z]+$/,
    message: '请输入中文或英文'
  },
  nEnglish: {
    pattern: /^[0-9a-zA-Z]+$/,
    message: '请输入英文或数字'
  },
  sort: {
    pattern: /^(\+?[1-9]\d{0,2}|\+?999)$/,
    message: '请输入1~999的整数'
  },
  twoDecimal: {
    pattern: /^(?:[1-9]\d*|0)(?:\.\d{1,2})?$/,
    message: '请输入数字且不可超过两位小数'
  },
  elevenTwoDecimal: {
    pattern: /^([1-9]\d{0,9})([.]\d{1,2})?$|^0[.]([1-9]\d{0,1}|[0-9][1-9])$/,
    message: '请输入0.01-9999999999.99的数字且小数位不可超过两位'
  },
  interestRateDecimal: {
    pattern: /^([1-9]\d{0,1})([.]\d{1,2})?$|^0[.]([1-9]\d{0,1}|[0-9][1-9])$/,
    message: '请输入0.01-99.99的数字且小数位不可超过两位'
  },
  DigitalRange: {
    pattern: /^(?:[1-9]\d*|0)(?:\.\d{1,2})?$/,
    message: '请输入 1~999 的整数'
  },
  idCard: {
    pattern: /^(\d{18,18}|\d{15,15}|\d{17,17}X)$/,
    message: '请输入正确的身份证号，若含字母请大写'
  },
  email: {
    pattern: /^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,4})$/,
    message: '请输入正确的邮箱地址'
  },
  socializeCode: {
    pattern: /^[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}$/,
    message: '请输入正确的社会信用代码'
  },
  passport: {
    pattern:
      /(^[EeKkGgDdSsPpHh]\d{8}$)|(^(([Ee][a-fA-F])|([DdSsPp][Ee])|([Kk][Jj])|([Mm][Aa])|(1[45]))\d{7}$)/,
    message: '请输入正确的护照号'
  },
  bankCard: {
    pattern: /^([1-9]{1})(\d{14}|\d{18})$/,
    message: '请输入正确的银行卡号'
  },
  changeNum: {
    pattern: /^(?:[1-9]\d*|0)(?:\.\d{1,10})?$/,
    message: '请输入数字，可输入小数但不能超过10位。'
  },
  smsCode: {
    pattern: /^\d{6}$/,
    message: '请输入正确的6位数字验证码。'
  },
  webAddress: {
    pattern:
      /^((http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?)*$/,
    message: '请输入正确的网址'
  },
  gameNumber: {
    message: '请输入符合ISBN xxx-x-xxx-xxxxx-x 格式, 小于21位字符',
    pattern: /^[0-9a-zA-Z_ -]{1,22}$/
  },
  // ICP备案号不做格式强校验，仅作填写提示参考
  icpNumber: {
    message: '填写格式参考：省简称+ICP备+数字号+号+xxx，如：粤ICP备12345678号、粤ICP备12345678号-1',
    tip: '省简称+ICP备+数字号+号+xxx'
  }
};

const splitMultiValue = (value: string) =>
  value
    .split(/[;\n\r]+/)
    .map((item) => item.trim())
    .filter(Boolean);

const isPrivateOrReservedIpv4 = (ip: string) => {
  const parts = ip.split('.').map(Number);
  if (parts.length !== 4 || parts.some((part) => Number.isNaN(part) || part < 0 || part > 255)) {
    return true;
  }
  const [a, b] = parts;
  if (a === 10) return true;
  if (a === 172 && b >= 16 && b <= 31) return true;
  if (a === 192 && b === 168) return true;
  if (a === 127 || a === 0) return true;
  if (a === 169 && b === 254) return true;
  if (a >= 224) return true;
  return false;
};

export function validateServerIp(value: string) {
  const rawValue = value || '';
  if (rawValue.length > SERVER_IP_MAX_LENGTH) {
    return { result: false, message: `应用服务器IP地址最多输入${SERVER_IP_MAX_LENGTH}个字符` };
  }

  const ips = splitMultiValue(rawValue);
  if (!ips.length) {
    return { result: false, message: '应用服务器IP地址不能为空' };
  }

  const ipv4Pattern = /^(\d{1,3}\.){3}\d{1,3}$/;
  for (const ip of ips) {
    if (ip.toLowerCase() === 'localhost') {
      return { result: false, message: '禁止填写 localhost，仅支持公网IPv4地址' };
    }
    if (/[a-zA-Z]/.test(ip)) {
      return { result: false, message: '禁止填写域名，仅支持公网IPv4地址' };
    }
    if (ip.includes(':')) {
      return { result: false, message: '禁止填写端口，仅支持公网IPv4地址' };
    }
    if (!ipv4Pattern.test(ip)) {
      return { result: false, message: '请输入正确的公网IPv4地址' };
    }
    if (isPrivateOrReservedIpv4(ip)) {
      return { result: false, message: '禁止填写内网IP，仅支持公网IPv4地址' };
    }
  }

  return { result: true };
}

// ICP备案号不做格式校验，仅限制长度；格式由页面文案提示
export function validateIcpNumber(value: string) {
  const rawValue = value || '';
  if (rawValue.length > ICP_NUMBER_MAX_LENGTH) {
    return { result: false, message: `ICP备案号最多输入${ICP_NUMBER_MAX_LENGTH}个字符` };
  }
  return { result: true };
}

export function htmlRestore(str: string) {
  var s = '';
  if (str.length === 0) {
    return '';
  }
  s = str.replace(/&amp;/g, '&');
  s = s.replace(/&lt;/g, '<');
  s = s.replace(/&gt;/g, '>');
  s = s.replace(/&nbsp;/g, ' ');
  s = s.replace(/&#39;/g, "'");
  s = s.replace(/&quot;/g, '"');
  return s;
}
